import React from 'react';

/**
 * Native-only WebView. Web uses `app/uae-pass.web.tsx` and never renders this.
 */
export function AdhaUaePassWebView(_props: {
  authUrl: string;
  redirectUri: string;
  onCallbackUrl: (url: string) => void;
  onLoadError?: () => void;
}): null {
  return null;
}

export default AdhaUaePassWebView;
